import { CloseOutlined, ControlPointOutlined, GavelOutlined } from "@mui/icons-material";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import { Alert, AlertTitle, Button, CircularProgress, Dialog, Tooltip } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";

import { inject } from "../../../../../../lib/itn-ui-kit/services/service-container";
import useRevalidateParent from "../../../../../hooks/useRevalidateParent";
import axios from "../../../../api/axios";
import ApiRequestErrorHandler from "../../../../global/ApiRequestErrorHandler";
import FormatISODate from "../../../../global/FormatISODate";
import ModalButton from "../../../../global/ModalButton";
import ResponseModal from "../../../../global/ResponseModal";
import CaseAssignmentModal from "../../../../modules/ClientDetail/Case/CaseAssignment/CaseAssignmentModal";
import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";

import CaseSummaryContext from "./CaseSummaryV2/context/CaseSummaryContext";

export default function CaseAssignment({ caseObj }) {
  const { userToCaseAssignment } = useLoaderData();
  const revalidateParent = useRevalidateParent("rvClientDetail");
  const caseId = caseObj?.id ?? caseObj?.pk;
  const { caseDetail, setCaseDetail } = useContext(CaseSummaryContext);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [openAssignUser, setOpenAssignUser] = useState(false);
  const [currentCaseManager, setCurrentCaseManager] = useState("");
  const [openSuccess, setOpenSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [connectedUserList, setConnectedUserList] = useState("");
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [connectionToDelete, setConnectionToDelete] = useState("");
  const [primaryPn, setPrimaryPn] = useState("");
  const [secondaryPn, setSecondaryPn] = useState("");
  const [primaryLf, setPrimaryLf] = useState("");
  const [secondaryLf, setSecondaryLf] = useState("");
  const [userRemErr, setUserRemErr] = useState(false);
  const [userRemErrMess, setUserRemErrMess] = useState([]);
  const [displayLoading, setDisplayLoading] = useState(false);

  const permissions = {
    viewUserToCaseAssignments: "users.view_usertocaseassignments",
    addUserToCaseAssignments: "users.add_usertocaseassignments",
    deleteUserToCaseAssignments: "users.delete_usertocaseassignments",
  };
  const currentUserService = inject("current-user-service");
  const userPermissions = currentUserService?.userRoles?.permissions || [];
  const canViewUserToCaseAssignments = userPermissions.includes(
    permissions.viewUserToCaseAssignments
  );
  const canAddUserToCaseAssignments = userPermissions.includes(
    permissions.addUserToCaseAssignments
  );
  const canDeleteUserToCaseAssignments = userPermissions.includes(
    permissions.deleteUserToCaseAssignments
  );

  useEffect(() => {
    getUserToCaseAssignment();
  }, [userToCaseAssignment]);

  const getUserToCaseAssignment = () => {
    if (canViewUserToCaseAssignments) {
      setPrimaryPn("");
      setSecondaryPn("");
      setPrimaryLf("");
      setSecondaryLf("");
      setDisplayLoading(true);
      setConnectedUserList(userToCaseAssignment);
      setCurrentCaseManager(userToCaseAssignment);
      setCaseDetail({
        ...caseDetail,
        assigned:
          userToCaseAssignment && userToCaseAssignment?.length > 0
            ? userToCaseAssignment.map((dataItem) => ({
                id: dataItem.user?.pk,
                name: dataItem.user?.name,
                role: dataItem.role?.name,
              }))
            : [],
      });
      userToCaseAssignment?.map((item) => {
        let newVal;
        if (item.role.pk === 1) {
          newVal = item;
          setPrimaryPn(item);
        }
        if (item.role.pk === 2) {
          newVal = item;
          setSecondaryPn(item);
        }
        if (item.role.pk === 3) {
          newVal = item;
          setPrimaryLf(item);
        }
        if (item.role.pk === 4) {
          newVal = item;
          setSecondaryLf(item);
        }
        return newVal;
      });
      setDisplayLoading(false);
    }
  };

  const openDeleteModal = (userInfo) => {
    setConnectionToDelete(userInfo);
    setDeleteConfirmation(true);
  };

  const deleteRole = (pk) => {
    setDisplayLoading(true);
    axios
      .delete(`/api/user_case/${pk}/`, {})
      .then(function (response) {
        if (response.status < 400) {
          setDeleteSuccess(!deleteSuccess);
          setDeleteConfirmation(false);
          setSecondaryLf("");
          setPrimaryLf("");
          setPrimaryPn("");
          setSecondaryPn("");
          setDisplayLoading(false);
          revalidateParent();
        }
      })
      .catch(function (error) {
        const res = error.response.data;
        const errArr = ApiRequestErrorHandler(res);
        setUserRemErrMess(errArr);
        setUserRemErr(true);
        setDeleteSuccess(!deleteSuccess);
        setDisplayLoading(false);
      });
  };

  const assignModalOpen = () => {
    setOpenAssignUser(true);
  };

  const openAssignmentList = () => {
    setDialogOpen(true);
  };

  return displayLoading ? (
    <div className="mx-auto w-fit">
      <CircularProgress color="secondary" />
    </div>
  ) : (
    <div className="w-full self-center">
      {" "}
      {canViewUserToCaseAssignments ? (
        <>
          {!currentCaseManager ? (
            <div className="mx-auto w-fit">
              <CircularProgress color="secondary" />
            </div>
          ) : currentCaseManager.length === 0 ? (
            <Tooltip title="Assign Case Manager">
              <Button
                onClick={() => openAssignmentList()}
                className="m-auto block w-fit rounded-md bg-sky-200 p-2 font-bold text-black"
                disabled={canAddUserToCaseAssignments ? false : true}
              >
                ASSIGN USER TO CASE&nbsp;
                <ControlPointOutlined />
              </Button>
            </Tooltip>
          ) : (
            <Tooltip title="View user case relations">
              <Button
                className="block w-full items-center justify-evenly rounded-md p-2 text-sm font-bold text-black"
                onClick={() => openAssignmentList()}
                disabled={canAddUserToCaseAssignments ? false : true}
              >
                <div className="flex-start flex">
                  <span className="mb-2 mr-2 block w-1/2 rounded-md bg-purple-300 px-2 py-1 text-left">
                    {!primaryPn ? (
                      <>
                        No Primary Assigned
                        <AssignmentIndIcon />
                      </>
                    ) : (
                      <>
                        Primary: {primaryPn.user.name} <AssignmentIndIcon />
                      </>
                    )}
                  </span>
                  <span className="mb-2 block w-1/2 rounded-md bg-yellow-300 px-2 py-1 text-left">
                    {!primaryLf ? (
                      <>
                        No LF Manager&nbsp;
                        <GavelOutlined className="mr-2 w-[20px]" />
                      </>
                    ) : (
                      <>
                        Primary: {primaryLf.user.name} <GavelOutlined className="mr-2 w-[20px]" />
                      </>
                    )}
                  </span>
                </div>
                <div className="flex-start flex">
                  {!secondaryPn ? (
                    <></>
                  ) : (
                    <span className="mr-2 block w-1/2 rounded-md bg-purple-300 px-2 py-1 text-left">
                      Secondary: {secondaryPn.user.name} <AssignmentIndIcon />
                    </span>
                  )}

                  {!secondaryLf ? (
                    <></>
                  ) : (
                    <span className="block w-1/2 rounded-md bg-yellow-300 px-2 py-1 text-left">
                      Secondary: {secondaryLf.user.name} <GavelOutlined className="mr-2 w-[20px]" />
                    </span>
                  )}
                </div>
              </Button>
            </Tooltip>
          )}
        </>
      ) : (
        ""
      )}
      <Dialog open={dialogOpen}>
        <Alert variant="outlined" severity="info" role="alert" style={{ paddingRight: "40px" }}>
          <AlertTitle
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "0 0 1rem",
            }}
          >
            Assignment
            <Button onClick={() => setDialogOpen(false)} style={{ padding: "0" }}>
              <CloseOutlined />
            </Button>
          </AlertTitle>
          <h1
            style={{
              textAlign: "center",
              fontSize: "1.5rem",
              margin: "1rem 0",
            }}
          >
            Case Related Users
          </h1>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            {connectedUserList &&
              connectedUserList.map((user, idx) => {
                return (
                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    className="gap-2 p-1"
                    key={idx}
                  >
                    <Tooltip
                      title={`Added By: ${user?.createdBy?.name ?? "N/A"} on ${user?.createdAt ? FormatISODate(user.createdAt.toISOString()) : "N/A"}`}
                    >
                      <span style={{ display: "inline-flex", lineHeight: 0 }}>
                        <Svg
                          name={SvgEnum.HisInfo}
                          sx={{ height: "18px", width: "18px" }}
                          color={HNSColors.primary[500]}
                        />
                      </span>
                    </Tooltip>
                    <p>
                      <strong>{user?.role.name}</strong> : {user?.user.name}
                      &nbsp;
                    </p>
                    {canDeleteUserToCaseAssignments && user.canEdit && (
                      <Tooltip title="Delete user role">
                        <button
                          id="delete-user-role-btn"
                          style={{
                            background: "none",
                            border: "1px solid #d32f2f",
                            borderRadius: "50%",
                            width: "15px",
                            height: "15px",
                            fontSize: "9px",
                            color: "#d32f2f",
                          }}
                          onClick={() => openDeleteModal(user)}
                        >
                          x
                        </button>
                      </Tooltip>
                    )}
                  </div>
                );
              })}
            {canAddUserToCaseAssignments && (
              <div style={{ margin: "1rem auto" }}>
                <ModalButton
                  className="block"
                  action={assignModalOpen}
                  baseColor="#1976d2"
                  icon="add"
                  content={"Assign user to case"}
                />
              </div>
            )}
          </div>
        </Alert>
      </Dialog>
      {openAssignUser && (
        <CaseAssignmentModal
          caseId={caseId}
          revalidateParent={revalidateParent}
          setDisplayLoading={setDisplayLoading}
          setError={setError}
          setErrorMessage={setErrorMessage}
          setOpenAssignUser={setOpenAssignUser}
          setOpenSuccess={setOpenSuccess}
        />
      )}
      <Dialog open={deleteConfirmation}>
        <Alert variant="outlined" severity="error" role="error" style={{ paddingRight: "40px" }}>
          <AlertTitle
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "0 0 1rem",
            }}
          >
            Remove {!connectionToDelete.user ? "" : connectionToDelete.user.name} from client's case
            <Button onClick={() => setDeleteConfirmation(false)} style={{ padding: "0" }}>
              <CloseOutlined />
            </Button>
          </AlertTitle>
          <h1
            style={{
              textAlign: "center",
              fontSize: "1.5rem",
              margin: "1rem 0",
            }}
          >
            Clicking below will remove this user from the case. For some users, it will remove their
            ability to access this clients information.
          </h1>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <br />
            <Button onClick={() => deleteRole(connectionToDelete.id)}>Remove</Button>
          </div>
        </Alert>
      </Dialog>
      <ResponseModal
        title="User Assign Success"
        description="The user was successfully assigned to case"
        openBool={openSuccess}
        setOpenBool={setOpenSuccess}
      />
      <ResponseModal
        title="User assign failed"
        isError={true}
        openBool={error}
        setOpenBool={setError}
        errorMessage={errorMessage}
      />
      <ResponseModal
        title="User Removal Success"
        description="The user was successfully removed from this case"
        openBool={deleteSuccess}
        setOpenBool={setDeleteSuccess}
      />
      <ResponseModal
        title="User Removal Failed"
        isError={true}
        openBool={userRemErr}
        setOpenBool={setUserRemErr}
        errorMessage={userRemErrMess}
      />
    </div>
  );
}
